import dayjs from '@ivario-arc/shared/src/utils/dayjs';
import { useTranslation } from 'react-i18next';
import { IconType } from '@src/types/IconType';
import { Icon } from '@components/atoms/Icon';
import { Tag } from '@components/atoms/Tag';
import { SampleDto } from '@src/types/types';
import { Image } from '@components/atoms/Image';

interface SampleTeaserContentProps {
  sample: SampleDto;
  goToResult: () => void;
}

export function SampleTeaserContent({
  sample,
  goToResult,
}: SampleTeaserContentProps) {
  const { t } = useTranslation('component', { keyPrefix: 'sampleTeaser' });
  const { t: tDetails } = useTranslation('component', {
    keyPrefix: 'sampleDetails',
  });
  const { t: tDate } = useTranslation('date');

  return (
    <button
      key={sample.id}
      onClick={goToResult}
      data-testid={`details-${sample.id}`}
      className="bg-grey3light rounded-bonusLarge py-4 px-2 sm:px-5 grid grid-cols-[60px_1fr_12px] gap-x-2 sm:gap-x-6 items-center"
    >
      {sample.productImage ? (
        <Image
          image={sample.productImage}
          alt={sample.productName}
          sizes="60px"
          className="w-full h-full object-contain"
          lazy={false}
        />
      ) : (
        <div className="h-[60px] w-[60px] bg-grey2 rounded-md" />
      )}
      <div className="flex justify-between flex-col md:flex-row md:space-x-2">
        <div className="flex flex-col items-start text-start mb-2 md:mb-0">
          <h2 className="mb-0.5 font-semibold">{sample.productName}</h2>
          <div className="text-grey1 font-bold">{sample.code}</div>
          <div className="text-grey1 leading-4 hyphens-auto">
            {tDetails(`fields.samplingLocation`)}:{' '}
            {sample.collectionPoint || '-'}
          </div>
        </div>
        <div className="flex flex-col justify-start items-start md:items-end">
          {sample.status && <Tag text={t(sample.status)} />}
          <div className="text-grey1 font-normal text-sm text-start md:text-end text-nowrap leading-4 mt-1 md:mt-[23px]">
            {t('activationDate')}:{' '}
            {dayjs(sample.activatedAt).format(tDate('format'))}
          </div>
        </div>
      </div>
      <div className="h-full">
        <Icon type={IconType.ChevronRightThick} className="w-full h-full" />
      </div>
    </button>
  );
}
